import React, {useContext} from "react";
import Avatar from "../../components/shared/Avatar";
import {AuthContext} from "../../context/authContext";
import Badge from "react-bootstrap/Badge";
import ProviderUserMenuItems from "./ProviderUserMenuItems";

const ProviderUserMenu = () => {
  const {user} = useContext(AuthContext)

  return (
    <div className="navbar-nav col-md-6 justify-content-md-end dropdown ">
      <a href='#'
         className="d-block link-body-emphasis text-decoration-none position-relative dropdozwn-toggle"
         data-bs-toggle="dropdown" aria-expanded="false">

        <Avatar src={user.avatar} alt={user.fullName} width={40} height={40}
                className="rounded-circle object-fit-cover"/>
        <Badge pill={true} bg='danger'
               className='pointer position-absolute top-0 start-1000 translate-middle mt-2 lh-sm'
               style={{padding: "1px 5px 2px"}}>
          {user.unreadNotificationsCount}
        </Badge>
      </a>
      <ul className="dropdown-menu text-small">
        <ProviderUserMenuItems/>
      </ul>
    </div>
  )
}
export default ProviderUserMenu